// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {objKeySort, genSign, toshowis ,pcstyle} from './assets/js/common.js'
import './assets/css/style.css'
import './assets/css/animate.min.css'
import {addCookie, getCookie, delCookie} from './assets/js/cookie.js';
import axios from 'axios';
import md5 from 'js-md5';
import store from './store'
import postFun from "@/plugins/postFun.js"; //引入postFun函数
import VueLazyload from 'vue-lazyload';
import toast from "./assets/js/alert.js"; //引入toast函数
  //给Vue对象添加$toast方法
Vue.prototype.$toast = toast;
Vue.use(VueLazyload, {
  // 可选配置项，可省略
  error: '', // 加载失败时显示的图片
  loading: '', // 加载中时显示的图片
  preLoad: 1.2, // 预加载高度的比例
  attempt: 1 // 尝试加载次数
})
//给Vue对象添加$toast方法
Vue.prototype.$postFun = postFun;
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
// import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$md5 = md5;

Vue.prototype.axios = axios;

Vue.prototype.$cookieStore = {
  addCookie,
  getCookie,
  delCookie
}
Vue.prototype.$common = {
  objKeySort,
  genSign,
  toshowis,
  pcstyle
}

Vue.config.productionTip = false
/* eslint-disable no-new */


// 获取浏览器的默认语言
// let language= getCookie('language') || '';
// var lang = navigator.language || navigator.userLanguage || '';


// if (language) {
// 	store.state.language=language;
// }else{
// 	if (lang.indexOf('zh')!=-1) {
// 		store.state.language='china';
// 	}else{
// 		store.state.language='english';
// 	}
// }
store.dispatch("getlanguageData");



// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app')

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});
